export enum MaskingType {
  SHAPE = 'shape',
  FREEHAND = 'freehand',
  TEXT = 'text',
}

export enum MaskingEffect {
  NONE = 'none',
  COLOR_POP = 'colorpop',
}

export interface MaskingObject {
  type: MaskingType;
  maskEffect: MaskingEffect;
  imageWidth: number;
  imageHeight: number;
  insideMasking: boolean;
}
